var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2902 2.12885C11.4487 0.729026 13.2329 0.615543 14.2756 1.87538C15.3182 3.13523 15.2242 5.2913 14.0658 6.69113L12.3878 8.71883M6.72443 11C5.68184 9.74017 5.77575 7.58406 6.9342 6.18423L8.42307 4.3851",
    stroke: "#6AA13C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1951 7C11.3535 8.25983 11.2491 10.4159 9.96199 11.8158L8.09753 13.8434L6.23307 15.8712C4.94591 17.271 2.96336 17.3844 1.80492 16.1246C0.646486 14.8648 0.750839 12.7087 2.03799 11.3088L3.90248 9.28109",
    stroke: "#6AA13C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.277f5bbe97665c8d9a3408988f3eaaaf.svg";
export { ForwardRef as ReactComponent };